import { render } from "./Project.vue?vue&type=template&id=46ff6af4&lang=pug"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=46ff6af4&lang=scss"
script.render = render

export default script